import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    id: String,
    exclusive: { type: Boolean, default: true } // If true, closes other flyouts
  }

  toggle(event) {
    if (event) event.preventDefault()

    // Dispatch custom event to window
    const customEvent = new CustomEvent("flyout:toggle", {
      detail: {
        id: this.idValue,
        exclusive: this.exclusiveValue
      }
    })
    window.dispatchEvent(customEvent)
  }
}
